"use strict";
/**
 * 表格页面配置
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableitemconfig = exports.hashtable = void 0;
/**
 * hash表格配置
 */
exports.hashtable = {
    hs_a_board: {
        fs: "m:0+t:6+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2,m:1+t:23+f:!2,m:0+t:81+s:262144+f:!2",
        table: "hsj",
    },
    sh_a_board: {
        fs: "m:1+t:2+f:!2,m:1+t:23+f:!2",
        table: "hsj",
    },
    sh_a_board_zcz: {
        fs: "m:1+t:2+s:131072+f:!2,m:1+t:23+s:131072+f:!2",
        table: "hsj",
    },
    sh_a_board_hzz: {
        fs: "m:1+t:2+s:524288+f:!2,m:1+t:23+s:524288+f:!2",
        table: "hsj",
    },
    sz_a_board: {
        fs: "m:0+t:6+f:!2,m:0+t:80+f:!2",
        table: "hsj",
    },
    sz_a_board_zcz: {
        fs: "m:0+t:6+s:131072+f:!2,m:0+t:80+s:131072+f:!2",
        table: "hsj",
    },
    sz_a_board_hzz: {
        fs: "m:0+t:6+s:524288+f:!2,m:0+t:80+s:524288+f:!2",
        table: "hsj",
    },
    bj_a_board: {
        fs: "m:0+t:81+s:262144+f:!2",
        table: "hsj",
    },
    newshares: {
        fs: "m:0+f:8,m:1+f:8",
        table: "newstock",
    },
    gem_board: {
        fs: "m:0+t:80+f:!2",
        table: "hsj",
    },
    gem_board_zcz: {
        fs: "m:0+t:80+s:131072+f:!2",
        table: "hsj",
    },
    gem_board_hzz: {
        fs: "m:0+t:80+s:!131072+f:!2",
        table: "hsj",
    },
    kcb_board: {
        fs: "m:1+t:23+f:!2",
        table: "hsj",
    },
    sh_hk_board: {
        fs: "b:BK0707",
        table: "newstock",
    },
    sz_hk_board: {
        fs: "b:BK0804",
        table: "newstock",
    },
    hk_sh_stocks: {
        fs: "b:MK0144",
        hk_delayfs: "b:DLMK0144",
        show_hk_delay_info: true,
        table: "hk_hsgt",
    },
    hk_sz_stocks: {
        fs: "b:MK0146",
        hk_delayfs: "b:DLMK0146",
        show_hk_delay_info: true,
        table: "hk_hsgt",
    },
    b_board: {
        fs: "m:0+t:7+f:!2,m:1+t:3+f:!2",
        table: "hsj",
    },
    ab_comparison: {
        fs: "m:1+b:BK0498,m:0+b:BK0498",
        table: "ab_comparison",
    },
    ab_comparison_sh: {
        fs: "m:1+b:BK0498",
        table: "ab_comparison",
    },
    ab_comparison_sz: {
        fs: "m:0+b:BK0498",
        table: "ab_comparison",
    },
    st_board: {
        fs: "m:0+f:4,m:1+f:4",
        table: "hsj",
    },
    st_board_sh: {
        fs: "m:1+f:4",
        table: "hsj",
    },
    st_board_sz: {
        fs: "m:0+f:4",
        table: "hsj",
    },
    st_board_bj: {
        fs: "m:0+t:81+s:262144+f:4",
        table: "hsj",
    },
    st_board_kcb: {
        fs: "m:1+t:23+f:4",
        table: "hsj",
    },
    st_board_cyb: {
        fs: "m:0+t:80+f:4",
        table: "hsj",
    },
    staq_net_board: {
        fs: "m:0+s:3",
        table: "tuishi",
    },
    delisting_board: {
        fs: "m:0+t:!81+f:2048,m:1+f:2048,m:0+t:81+s:262144+f:2048",
        table: "hsj",
    },
    delisting_board_sh: {
        fs: "m:1+f:2048",
        table: "hsj",
    },
    delisting_board_sz: {
        fs: "m:0+t:!81+f:2048",
        table: "hsj",
    },
    delisting_board_bj: {
        fs: "m:0+t:81+s:262144+f:2048",
        table: "hsj",
    },
    neeq_stocks: {
        fs: "m:0+t:81+s:!2052",
        table: "xinsanban",
    },
    neeq_innovate: {
        fs: "m:0+s:512",
        table: "xinsanban",
    },
    neeq_basic: {
        fs: "m:0+s:256",
        table: "xinsanban",
    },
    neeq_marketmaking: {
        fs: "m:0+s:128",
        table: "xinsanban",
    },
    neeq_bidding: {
        fs: "m:0+s:32",
        table: "xinsanban",
    },
    forex_exchange_icbc: {
        fs: "m:162+s:1",
        table: "forex_nolink",
    },
    forex_exchange_abc: {
        fs: "m:162+s:2",
        table: "forex_nolink",
    },
    forex_exchange_boc: {
        fs: "m:162+s:4",
        table: "forex_nolink",
    },
    forex_exchange_ccb: {
        fs: "m:162+s:8",
        table: "forex_nolink",
    },
    forex_exchange_bcm: {
        fs: "m:162+s:16",
        table: "forex_nolink",
    },
    forex_exchange_cmb: {
        fs: "m:162+s:32",
        table: "forex_nolink",
    },
    gold_sh_spotgoods: {
        fs: "m:118",
        table: "gold",
    },
    gold_sh_futures: {
        fs: "m:113+t:5",
        table: "qihuo1",
    },
    nobalmetal_spotgoods: {
        fs: "m:122,m:123",
        table: "gold",
    },
    nobalmetal_futures: {
        fs: "i:111.JAGC,i:101.QI00Y,i:111.JPAC,i:101.HG00Y,i:111.JAUC,i:111.JPLC,i:102.PL00Y,i:101.QO00Y,i:101.MGC00Y,i:101.GC00Y,i:101.SI00Y,i:102.PA00Y",
        table: "gold",
    },
    us_stocks: {
        fs: "m:105,m:106,m:107",
        table: "us_all",
    },
    us_wellknown: {
        fs: "b:MK0001",
        table: "us_stock",
    },
    us_chinese: {
        fs: "b:MK0201",
        table: "us_china",
    },
    us_chinese_internet: {
        fs: "b:MK0202",
        table: "us_china",
    },
    us_index: {
        fs: "i:100.NDX,i:100.DJIA,i:100.SPX",
        table: "us_zs",
    },
    us_pinksheet: {
        fs: "m:153",
        table: "us_common",
    },
    us_technology: {
        fs: "b:MK0216",
        table: "us_common",
    },
    us_financial: {
        fs: "b:MK0217",
        table: "us_common",
    },
    us_medicine_food: {
        fs: "b:MK0218",
        table: "us_common",
    },
    us_media: {
        fs: "b:MK0220",
        table: "us_common",
    },
    us_automotive_energy: {
        fs: "b:MK0219",
        table: "us_common",
    },
    us_manufacture_retail: {
        fs: "b:MK0221",
        table: "us_common",
    },
    stocks_all: {
        fs: "m:155+t:1,m:155+t:2,m:155+t:3,m:156+t:1,m:156+t:2,m:156+t:5,m:156+t:6,m:156+t:7,m:156+t:8",
        table: "uk_common",
    },
    stocks_mt_156_7: {
        fs: "m:156+t:7",
        table: "uk_common",
    },
    stocks_b_mk0794: {
        fs: "b:MK0794",
        table: "uk_common",
    },
    stocks_mt_155_3: {
        fs: "m:155+t:3",
        table: "uk_common",
    },
    stocks_mt_341: {
        fs: "m:341",
        table: "uk_common",
    },
    stocks_mt_252_1: {
        fs: "m:252+t:1",
        table: "uk_common",
    },
    global_asia: {
        fs: "i:1.000001,i:0.399001,i:0.399005,i:0.399006,i:1.000300,i:100.HSI,i:100.HSCEI,i:124.HSCCI,i:100.TWII,i:100.N225,i:100.KOSPI200,i:100.KS11,i:100.STI,i:100.SENSEX,i:100.KLSE,i:100.SET,i:100.PSI,i:100.KSE100,i:100.VNINDEX,i:100.JKSE,i:100.CSEALL",
        table: "qqzs_common",
    },
    global_euro: {
        fs: "i:100.SX5E,i:100.FTSE,i:100.MCX,i:100.AXX,i:100.FCHI,i:100.GDAXI,i:100.RTS,i:100.IBEX,i:100.PSI20,i:100.OMXC20,i:100.BFX,i:100.AEX,i:100.WIG,i:100.OMXSPI,i:100.SSMI,i:100.HEX,i:100.OSEBX,i:100.ATX,i:100.MIB,i:100.ASE,i:100.ICEXI,i:100.PX,i:100.ISEQ",
        table: "qqzs_common",
    },
    global_america: {
        fs: "i:100.DJIA,i:100.SPX,i:100.NDX,i:100.TSX,i:100.BVSP,i:100.MXX",
        table: "qqzs_common",
    },
    global_australia: {
        fs: "i:100.AS51,i:100.AORD,i:100.NZ50",
        table: "qqzs_common",
    },
    global_qtzs: {
        fs: "i:100.UDI,i:100.BDI,i:100.CRB",
        table: "qqzs_common",
    },
    // 延时delayfs
    ah_comparison: {
        fs: "b:MK0101",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0101",
        table: "ah_table",
    },
    hkah_comparison: {
        fs: "b:MK0101",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0101",
        table: "ah_table",
    },
    hk_stocks: {
        fs: "m:116+t:3,m:116+t:4,m:116+t:1,m:116+t:2",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+t:3,m:128+t:4,m:128+t:1,m:128+t:2",
        table: "hk_stock",
    },
    hk_mainboard: {
        fs: "m:116+t:3",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+t:3",
        table: "hk_stock",
    },
    hk_gem: {
        fs: "m:116+t:4",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+t:4",
        table: "hk_stock",
    },
    hk_wellknown: {
        fs: "b:MK0106",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0106",
        table: "hk_stock",
    },
    hk_bluechips: {
        fs: "b:MK0105",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0105",
        table: "hk_stock",
    },
    hk_redchips: {
        fs: "b:MK0102",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0102",
        table: "hk_stock",
    },
    hk_redchips_components: {
        fs: "b:MK0111",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0111",
        table: "hk_stock",
    },
    hk_stateowned: {
        fs: "b:MK0103",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0103",
        table: "hk_stock",
    },
    hk_stateowned_components: {
        fs: "b:MK0112",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0112",
        table: "hk_stock",
    },
    hk_components: {
        fs: "b:MK0146,b:MK0144",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0146,b:DLMK0144",
        table: "hk_stock",
    },
    hsi_large_components: {
        fs: "b:MK0141",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0141",
        table: "hk_stock",
    },
    hsi_medium_components: {
        fs: "b:MK0142",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0142",
        table: "hk_stock",
    },
    hk_index: {
        fs: "m:124,m:125,m:305",
        // delayfs: "m:124,m:125,m:305", // 特殊无延时
        table: "hk_zs",
    },
    hk_warrants: {
        fs: "m:116+t:6",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+t:6",
        table: "hk_zs",
    },
    hk_cbbcs: {
        fs: "m:116+t:5",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+t:5",
        table: "hk_CBBC",
    },
    hk_adr: {
        fs: "m:116+s:1",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+s:1",
        table: "hk_adr",
    },
    hk_rmb: {
        fs: "m:116+s:64",
        show_hk_delay_info: true,
        hk_delayfs: "m:128+s:64",
        table: "hk_rmb",
    },
    sh_hk_board_fund: {
        fs: "b:MK0839",
        table: "hsgt_etf",
    },
    sz_hk_board_fund: {
        fs: "b:MK0840",
        table: "hsgt_etf",
    },
    hk_sh_board_fund: {
        fs: "b:MK0838",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0838",
        table: "hsgt_etf2",
    },
    hk_sz_board_fund: {
        fs: "b:MK0837",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0837",
        table: "hsgt_etf2",
    },
    ggt_etf_board: {
        fs: "b:MK0838+b:MK0837",
        show_hk_delay_info: true,
        hk_delayfs: "b:DLMK0838+b:DLMK0837",
        table: "hsgt_etf2",
    },
    fund_close_end: {
        fs: "e:19",
        table: "hsgt_etf",
    },
    fund_etf: {
        fs: "b:MK0021,b:MK0022,b:MK0023,b:MK0024,b:MK0827",
        table: "hsgt_etf",
    },
    fund_lof: {
        fs: "b:MK0404,b:MK0405,b:MK0406,b:MK0407",
        table: "hsgt_etf",
    },
    fund_reits_all: {
        fs: "m:1+t:9+e:97,m:0+t:10+e:97",
        table: "reits",
    },
    fund_reits_sh: {
        fs: "m:1+t:9+e:97",
        table: "reits",
    },
    fund_reits_sz: {
        fs: "m:0+t:10+e:97",
        table: "reits",
    },
    bond_index: {
        fs: "i:1.000012,i:1.000013,i:1.000022,i:1.000061,i:0.395021,i:0.395022,i:0.395031,i:0.395032,i:0.399481",
        table: "zqsc",
    },
    bond_sh: {
        fs: "m:1+t:4",
        table: "zqsc",
    },
    bond_national_sh: {
        fs: "m:1+b:MK0351",
        table: "zqsc2",
    },
    bond_enterprise_sh: {
        fs: "m:1+b:MK0353",
        table: "zqsc2",
    },
    bond_convertible_sh: {
        fs: "m:1+b:MK0354",
        table: "zqsc",
    },
    bond_sz: {
        fs: "m:0+t:8",
        table: "zqsc",
    },
    bond_national_sz: {
        fs: "m:0+b:MK0351",
        table: "zqsc2",
    },
    bond_enterprise_sz: {
        fs: "m:0+b:MK0353",
        table: "zqsc2",
    },
    bond_bj: {
        fs: "m:0+t:35",
        table: "zqsc",
    },
    bond_enterprise_bj: {
        fs: "m:0+t:35+e:10",
        table: "zqsc",
    },
    bond_convertible_sz: {
        fs: "m:0+b:MK0354",
        table: "zqsc",
    },
    bond_sh_buyback: {
        fs: "m:1+b:MK0356",
        table: "zqsc2",
    },
    bond_sz_buyback: {
        fs: "m:0+b:MK0356",
        table: "zqsc2"
    },
    convertible_comparison: {
        fs: "b:MK0354",
        table: "kzhbj"
    },
    forex_all: {
        fs: "m:119,m:120,m:133",
        table: "whsc"
    },
    forex_basic: {
        fs: "b:MK0300",
        table: "whsc"
    },
    forex_cross: {
        fs: "b:MK0301",
        table: "whsc"
    },
    forex_cny: {
        fs: "m:120+t:!2,m:133",
        table: "whsc"
    },
    forex_cnyc: {
        fs: "b:MK0002",
        table: "whsc_forex_cnyc"
    },
    // forex_cnyi: {
    //   fs: "m:121+t:1",
    //   table: "whsc"
    // },
    forex_cnh: {
        fs: "m:133",
        table: "whsc"
    },
    index_sh: {
        fs: "m:1+t:1",
        table: "hsjzs"
    },
    index_sz: {
        fs: "m:0+t:5",
        table: "hsjzs"
    },
    index_components: {
        fs: "m:1+s:3,m:0+t:5",
        table: "hsjzs"
    },
    index_zzzs: {
        fs: "m:2",
        table: "hsjzs"
    },
    concept_board: {
        fs: "m:90+t:3+f:!50",
        table: "bk_common"
    },
    region_board: {
        fs: "m:90+t:1+f:!50",
        table: "bk_common"
    },
    industry_board: {
        fs: "m:90+t:2+f:!50",
        table: "bk_common"
    },
    industry_board_1: {
        fs: "m:90+s:2+f:!50",
        table: "bk_common"
    },
    industry_board_2: {
        fs: "m:90+s:4+f:!50",
        table: "bk_common"
    },
    industry_board_3: {
        fs: "m:90+s:8+f:!50",
        table: "bk_common"
    },
    options_qqsc_index: {
        fs: "m:10,m:140,m:141,m:151,m:163,m:226",
        table: "option"
    },
    options_sh50etf_all: {
        fs: "m:10",
        table: "option"
    },
    options_sh50etf_call: {
        fs: "m:10+t:173",
        table: "option"
    },
    options_sh50etf_put: {
        fs: "m:10+t:174",
        table: "option"
    },
    options_szetf_all: {
        fs: "m:12",
        table: "option"
    },
    options_sz50etf_all: {
        fs: "m:10+c:510050",
        table: "option"
    },
    options_sz50etf_rengou: {
        fs: "m:10+c:510050+t:173",
        table: "option"
    },
    options_kc50etf_all: {
        fs: "m:10+c:588000,m:10+c:588080",
        table: "option"
    },
    options_sz50etf_rengu: {
        fs: "m:10+c:510050+t:174",
        table: "option"
    },
    options_sahs300etf_all: {
        fs: "m:10+c:510300",
        table: "option"
    },
    options_sahs300etf_rengou: {
        fs: "m:10+c:510300+t:173",
        table: "option"
    },
    options_sahs300etf_rengu: {
        fs: "m:10+c:510300+t:174",
        table: "option"
    },
    options_sazz500etf_all: {
        fs: "m:10+c:510500",
        table: "option"
    },
    options_sazz500etf_rengou: {
        fs: "m:10+c:510500+t:173",
        table: "option"
    },
    options_sazz500etf_rengu: {
        fs: "m:10+c:510500+t:174",
        table: "option"
    },
    options_kc50etf1_all: {
        fs: "m:10+c:588000",
        table: "option"
    },
    options_kc50etf1_rengou: {
        fs: "m:10+c:588000+t:173",
        table: "option"
    },
    options_kc50etf1_rengu: {
        fs: "m:10+c:588000+t:174",
        table: "option"
    },
    options_kc50etf2_all: {
        fs: "m:10+c:588080",
        table: "option"
    },
    options_kc50etf2_rengou: {
        fs: "m:10+c:588080+t:173",
        table: "option"
    },
    options_kc50etf2_rengu: {
        fs: "m:10+c:588080+t:174",
        table: "option"
    },
    options_sehs300etf_all: {
        fs: "m:12+c:159919",
        table: "option"
    },
    options_sehs300etf_rengou: {
        fs: "m:12+c:159919+t:178",
        table: "option"
    },
    options_sehs300etf_rengu: {
        fs: "m:12+c:159919+t:179",
        table: "option"
    },
    options_sezz500etf_all: {
        fs: "m:12+c:159922",
        table: "option"
    },
    options_sezz500etf_rengou: {
        fs: "m:12+c:159922+t:178",
        table: "option"
    },
    options_sezz500etf_rengu: {
        fs: "m:12+c:159922+t:179",
        table: "option"
    },
    options_secybetf_all: {
        fs: "m:12+c:159915",
        table: "option"
    },
    options_secybetf_rengou: {
        fs: "m:12+c:159915+t:178",
        table: "option"
    },
    options_secybetf_rengu: {
        fs: "m:12+c:159915+t:179",
        table: "option"
    },
    options_sz50etf_txbj: {
        name: "50ETF",
        fs: "1.510050",
        table: "option_txbj"
    },
    options_sahs300etf_txbj: {
        name: "300ETF",
        fs: "1.510300",
        table: "option_txbj"
    },
    options_sazz500etf_txbj: {
        name: "500ETF",
        fs: "1.510500",
        table: "option_txbj"
    },
    options_kc50etf1_txbj: {
        name: "科创50",
        fs: "1.588000",
        table: "option_txbj"
    },
    options_kc50etf2_txbj: {
        name: "科创板50",
        fs: "1.588080",
        table: "option_txbj"
    },
    options_sehs300etf_txbj: {
        name: "300ETF",
        fs: "0.159919",
        table: "option_txbj"
    },
    options_sezz500etf_txbj: {
        name: "500ETF",
        fs: "0.159922",
        table: "option_txbj"
    },
    options_secybetf_txbj: {
        name: "创业板ETF",
        fs: "0.159915",
        table: "option_txbj"
    }
};
/**
 * 表格字段配置
 */
exports.tableitemconfig = {
    hsj: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "astock_xg_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "ChangePercent"
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
            sort_alias: "Amplitude"
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "量比",
            type: "quote",
            value: "量比",
            sort: true,
            sort_alias: "VolumeRate"
        },
        {
            title: "换手率",
            type: "quote",
            value: "换手率",
            sort: true,
            sort_alias: "TurnoverRate"
        },
        {
            title: "市盈率(动态)",
            type: "quote",
            value: "市盈率动态",
            sort: true,
            sort_alias: "PERation"
        },
        {
            type: "custom"
        },
        {
            title: "加自选",
            type: "add_zxg",
        },
        // {
        //   title: "5分钟涨跌",
        //   type: "quote",
        //   value: "涨跌幅_5分钟",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "FiveMinuteChangePercent"
        // },
        // {
        //   title: "流通市值",
        //   type: "quote",
        //   value: "流通市值",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "FlowCapitalValue"
        // },
        // {
        //   title: "总市值",
        //   type: "quote",
        //   value: "总市值",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "MarketValue"
        // },
        // {
        //   title: "60日涨跌幅",
        //   type: "quote",
        //   value: "涨跌幅_60日",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "ChangePercent60Day"
        // },
        // {
        //   title: "年初至今涨跌幅",
        //   type: "quote",
        //   value: "年初至今涨跌幅",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "ChangePercent360Day"
        // },
        // {
        //   title: "涨速",
        //   type: "quote",
        //   value: "涨速_3分钟",
        //   sort: true,
        //   hide: true,
        //   sort_alias: "Speed"
        // }
    ],
    hsjzs: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: ""
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "量比",
            type: "quote",
            value: "量比",
            sort: true,
        }
    ],
    newstock: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "astock_xg_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "量比",
            type: "quote",
            value: "量比",
            sort: true,
        },
        {
            title: "换手率",
            type: "quote",
            value: "换手率",
            sort: true,
        },
        {
            title: "市盈率(动态)",
            type: "quote",
            value: "市盈率动态",
            sort: true,
        },
        {
            type: "custom"
        },
        {
            title: "上市时间",
            type: "quote",
            value: "上市日期",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "加自选",
            type: "add_zxg",
        }
    ],
    ab_comparison: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "B股代码",
            type: "quote",
            value: "AB股对应的代码",
            sort: true
        },
        {
            title: "名称",
            type: "quote",
            value: "AB股对应的名称",
            sort: true,
        },
        {
            title: "相关链接",
            type: "astock_xg_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "AB股对应的最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "AB股对应的涨跌幅",
            sort: true
        },
        {
            title: "A股代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "比价(A/B)",
            type: "quote",
            value: "AB股比价",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
    ],
    tuishi: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            hide: true
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "gb_zx_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "委比",
            type: "quote",
            value: "委比",
            sort: true,
        }
    ],
    delisting: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            hide: true
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "gb_zx_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "委比",
            type: "quote",
            value: "委比",
            sort: true,
        }
    ],
    xinsanban: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            type: "quote",
            value: "名称",
            hide: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "新三板行情统一链接",
            tdclass: "xsb_name",
            sort: true,
        },
        {
            title: "相关链接",
            type: "gb_zx_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "委比",
            type: "quote",
            value: "委比",
            sort: true,
        },
    ],
    us_stock: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(美元)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
            sort_alias: "ChangePercent"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "总市值(美元)",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "市盈率",
            type: "quote",
            value: "市盈率TTM",
            sort: true,
        },
    ],
    forex_nolink: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            hide: true,
        },
        {
            title: "现汇买入价",
            type: "quote",
            value: "买入价或买一价",
            sort: true,
        },
        {
            title: "现钞买入价",
            type: "quote",
            value: "买二价",
            sort: true,
        },
        {
            title: "现汇卖出价",
            type: "quote",
            value: "卖出价或卖一价",
            sort: true,
        },
        {
            title: "现钞卖出价",
            type: "quote",
            value: "卖二价",
            sort: true,
        },
        {
            title: "更新时间",
            type: "quote",
            value: "交易时间",
            sort: true,
        },
    ],
    gold: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "品种",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价用昨结计算",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价用昨结计算",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价用昨结计算",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "更新时间",
            type: "quote",
            value: "交易时间",
            sort: true,
        },
    ],
    qihuo1: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价用昨结计算",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价用昨结计算",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价用昨结计算",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "买盘(外盘)",
            type: "quote",
            value: "外盘_买盘",
            sort: true,
        },
        {
            title: "卖盘(内盘)",
            type: "quote",
            value: "内盘_卖盘",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        }
    ],
    us_all: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(美元)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "ChangePercent"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价用昨结计算",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价用昨结计算",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价用昨结计算",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "总市值(美元)",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "市盈率",
            type: "quote",
            value: "市盈率TTM",
            sort: true,
        }
    ],
    us_china: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(美元)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "ChangePercent"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价用昨结计算",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价用昨结计算",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价用昨结计算",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "总市值(美元)",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "市盈率",
            type: "quote",
            value: "市盈率TTM",
            sort: true,
        }
    ],
    us_zs: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "带交易状态的名称",
            sort: true,
            tdclass: "qqzs_name"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价用昨结计算",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价用昨结计算",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价用昨结计算",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
        },
        {
            title: "最新行情时间",
            type: "quote",
            value: "交易时间",
            sort: true,
        }
    ],
    us_common: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(美元)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
            sort_alias: "ChangePercent"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "总市值(美元)",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "市盈率",
            type: "quote",
            value: "市盈率TTM",
            sort: true,
        },
    ],
    uk_common: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "总市值",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "市盈率(ttm)",
            type: "quote",
            value: "市盈率TTM",
            sort: true,
        },
    ],
    qqzs_common: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "名称",
            type: "quote",
            value: "带交易状态的名称",
            sort: true,
            tdclass: "qqzs_name"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收价",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
        },
        {
            title: "最新行情时间",
            type: "quote",
            value: "交易时间",
            sort: true,
        },
    ],
    ah_table: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "名称",
            type: "quote",
            value: "H股对应的A股行情统一链接",
            sort: true,
        },
        {
            title: "H股代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "最新价(HKD)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
        },
        {
            title: "港股吧",
            type: "gb_hk_link"
        },
        {
            title: "A股代码",
            type: "quote",
            value: "H股对应的A股代码",
            sort: true,
        },
        {
            title: "最新价(RMB)",
            type: "quote",
            value: "H股对应的A股最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "H股对应的A股涨跌幅",
            sort: true,
        },
        {
            title: "A股吧",
            type: "gb_hka_link",
        },
        {
            title: "比价(A/H)",
            type: "quote",
            value: "AH股比价",
            sort: true,
        },
        {
            title: "溢价(A/H)%",
            type: "quote",
            value: "AH股溢价",
            sort: true,
        },
    ],
    hk_stock: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            hide: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true
        },
        {
            title: "证券类型",
            type: "quote",
            value: "证券类型",
            hide: true,
        },
        {
            title: "相关链接",
            type: "hk_xg_link"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
            sort_alias: "ChangePercent"
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "加自选",
            type: "add_zxg",
        },
    ],
    hk_zs: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(HKD)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
            sort_alias: "ChangePercent"
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额(港元)",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        }
    ],
    hk_hsgt: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            hide: true,
        },
        {
            title: "证券类型",
            type: "quote",
            value: "证券类型",
            hide: true,
        },
        {
            title: "相关链接",
            type: "hk_xg_link"
        },
        {
            title: "最新价(HKD)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "ChangePercent"
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额(港元)",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "加自选",
            type: "add_zxg",
        }
    ],
    hk_CBBC: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(HKD)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额(港元)",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "Amount"
        }
    ],
    hk_adr: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "港股名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "港股代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "ADR代码",
            type: "quote",
            value: "ADR代码带链接",
            sort: true,
        },
        {
            title: "ADR收市价(USD)",
            type: "quote",
            value: "ADR收市价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "ADR涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "ADR涨跌幅",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            hide: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "折合每股港元",
            type: "quote",
            value: "ADR折合每股港元",
            sort: true
        },
    ],
    hk_rmb: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "名称",
            hide: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "证券类型",
            type: "quote",
            value: "证券类型",
            hide: true,
        },
        {
            title: "相关链接",
            type: "hk_xg_link"
        },
        {
            title: "最新价(RMB)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort_default: true,
            sort_direct: 1,
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额(人民币)",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "加自选",
            type: "add_zxg",
        }
    ],
    hsgt_etf: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "jj_etf_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        }
    ],
    hsgt_etf2: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价(HKD)",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(股)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额(港元)",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        }
    ],
    reits: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: ""
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        },
        {
            title: "开盘价",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高价",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低价",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        }
    ],
    zqsc: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: "reits_name"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_alias: "Amount"
        }
    ],
    zqsc2: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: "reits_name"
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
            sort_alias: "Volume"
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "Amount"
        }
    ],
    kzhbj: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "转债名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: ""
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
        },
        {
            title: "相关链接",
            type: "gb_kzz_link",
        },
        {
            title: "正股代码",
            type: "quote",
            value: "可转债对应的正股代码",
            sort: true,
        },
        {
            title: "正股名称",
            type: "quote",
            value: "可转债对应的正股名称",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "可转债对应的正股最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "可转债对应的正股涨跌幅",
            sort: true,
        },
        {
            title: "转股价",
            type: "quote",
            value: "可转债转股价",
            sort: true,
        },
        {
            title: "转股价值",
            type: "quote",
            value: "可转债转股价值",
            sort: true,
            tip: "<span class='icon_kzh' title='转股价值=正股价/转股价*100'></span>"
        },
        {
            title: "转股溢价率",
            type: "quote",
            value: "可转债转股溢价率",
            sort: true,
            tip: "<span class='icon_kzh' title='转股溢价率 = (转债最新价 – 转股价值)/ 转股价值'></span>"
        },
        {
            title: "纯债溢价率",
            type: "quote",
            value: "可转债纯债溢价率",
            sort: true,
            tip: "<span class='icon_kzh' title='纯债溢价率 = (转债最新价 – 纯债价值)/ 纯债价值'></span>"
        },
        {
            title: "回售触发价",
            type: "quote",
            value: "可转债回售触发价",
            sort: true,
            tip: "<span class='icon_kzh' title='满足回售触发条件时，可转债持有人有权将其持有的可转债全部或部分按债券面值加上当期应计利息的价格回售给公司'></span>"
        },
        {
            title: "强赎触发价",
            type: "quote",
            value: "可转债强赎触发价",
            sort: true,
            tip: "<span class='icon_kzh' title='满足赎回触发条件时，公司有权按照债券面值加当期应计利息的价格赎回全部或部分未转股的可转债'></span>"
        },
        {
            title: "到期赎回价",
            type: "quote",
            value: "可转债到期赎回价",
            sort: true,
            tip: "<span class='icon_kzh' title='公司有权以债券发行说明书中规定的到期赎回价买回其发行在外债券'></span>"
        },
        {
            title: "纯债价值",
            type: "quote",
            value: "可转债纯债价值",
            sort: true
        },
        {
            title: "开始转股日",
            type: "quote",
            value: "可转债开始转股日",
            sort: true
        },
        {
            title: "上市日期",
            type: "quote",
            value: "上市日期",
            sort: true
        },
        {
            title: "申购日期",
            type: "quote",
            value: "可转债申购日",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "加自选",
            type: "add_zxg",
        },
        {
            title: "市场",
            type: "quote",
            value: "市场",
            hide: true
        }
    ],
    whsc: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: ""
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        }
    ],
    whsc_forex_cnyc: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tdclass: ""
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        }
    ],
    bk_common: [
        {
            title: "排名",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            hide: true,
        },
        {
            title: "板块名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "gb_zj_yb_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
            sort_alias: "ChangePercent"
        },
        {
            title: "总市值",
            type: "quote",
            value: "总市值",
            sort: true,
        },
        {
            title: "换手率",
            type: "quote",
            value: "换手率",
            sort: true,
            sort_alias: "TurnoverRate"
        },
        {
            title: "上涨家数",
            type: "quote",
            value: "板块或指数上涨数量",
            sort: true,
        },
        {
            title: "下跌家数",
            type: "quote",
            value: "板块或指数下跌数量",
            sort: true,
        },
        {
            title: "领涨股票/领跌股票",
            type: "sort_change",
            desc: {
                title: "领涨股票",
                value: "板块领涨股"
            },
            esc: {
                title: "领跌股票",
                value: "板块领跌股"
            }
        },
        {
            title: "领涨股票/领跌股票-涨跌幅",
            type: "sort_change",
            desc: {
                title: "涨跌幅",
                value: "板块领涨股涨跌幅"
            },
            esc: {
                title: "涨跌幅",
                value: "板块领跌股涨跌幅"
            }
        }
    ],
    bkchild: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "相关链接",
            type: "astock_xg_link",
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "成交量(手)",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "振幅",
            type: "quote",
            value: "振幅",
            sort: true,
        },
        {
            title: "最高",
            type: "quote",
            value: "最高价",
            sort: true,
        },
        {
            title: "最低",
            type: "quote",
            value: "最低价",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "今开价",
            sort: true,
        },
        {
            title: "昨收",
            type: "quote",
            value: "昨收价",
            sort: true,
        },
        {
            title: "量比",
            type: "quote",
            value: "量比",
            sort: true,
            sort_alias: "VolumeRate"
        },
        {
            title: "换手率",
            type: "quote",
            value: "换手率",
            sort: true,
            sort_alias: "TurnoverRate"
        },
        {
            title: "市盈率(动态)",
            type: "quote",
            value: "市盈率动态",
            sort: true,
            sort_alias: "PERation"
        },
        {
            type: "custom"
        },
        {
            title: "加自选",
            type: "add_zxg",
        }
    ],
    option: [
        {
            title: "序号",
            type: "index",
        },
        {
            title: "代码",
            type: "quote",
            value: "代码带链接",
            sort: true,
        },
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
        },
        {
            title: "最新价",
            type: "quote",
            value: "最新价",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "涨跌额",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "涨跌幅",
            sort: true,
            sort_default: true,
            sort_direct: 1,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "成交额",
            type: "quote",
            value: "成交额",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
        {
            title: "行权价",
            type: "quote",
            value: "期权行权价",
            sort: true,
        },
        {
            title: "剩余日",
            type: "quote",
            value: "期权剩余期限",
            sort: true,
        },
        {
            title: "日增",
            type: "quote",
            value: "期货日增",
            sort: true,
        },
        {
            title: "昨结",
            type: "quote",
            value: "昨结",
            sort: true,
        },
        {
            title: "今开",
            type: "quote",
            value: "期货今开",
            sort: true,
        }
    ],
    option_txbj: [
        {
            title: "名称",
            type: "quote",
            value: "行情统一链接",
            sort: true,
            tip: "<span class='icon_qa_tit' title='非标准合约第一次调整，行权价增加标识A；第二次调整，行权价增加标识B'></span>"
        },
        {
            title: "最新",
            type: "quote",
            value: "期权最新价",
            sort: true,
        },
        {
            title: "期权标的券最新价",
            type: "quote",
            value: "期权标的券最新价",
            hide: true
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "期权涨跌幅",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "期权涨跌额",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "持仓量",
            sort: true,
        },
        {
            title: "成交量",
            type: "quote",
            value: "成交量",
            sort: true,
        },
        {
            title: "隐含波动率",
            type: "quote",
            value: "期权隐含波动率",
            sort: true,
            tip: "<span class='icon_qa_tit' title='隐含波动率(Implied Volatility)是将市场上的期权或权证交易价格代入权证理论价格模型<Black-Scholes模型>，反推出来的波动率数值'></span>"
        },
        {
            title: "折溢价率",
            type: "quote",
            value: "期权折溢价率",
            sort: true,
            tip: "<span class='icon_qa_tit' title='期权到期前，标的物价格需要变动多少百分比才可让期权投资者在到期日实现损益平衡。溢价率衡量期权风险高低，该值越高，实现损益平衡越不容易，投资风险越高'></span>"
        },
        {
            title: "行权价",
            type: "quote",
            value: "期权T型报价行权价",
            sort: true,
            sort_default: true,
            sort_direct: 0,
            tdclass: "xq_orange",
            tip: "<span class='icon_qa_tit' title='T型报价的行权价以同一行权价格为中心，左侧为认购期权的相关行情，右侧为认沽期权相关行情'></span>"
        },
        {
            title: "名称",
            type: "quote",
            value: "认沽认购期权名称",
            sort: true,
            tip: "<span class='icon_qa_tit' title='非标准合约第一次调整，行权价增加标识A；第二次调整，行权价增加标识B'></span>"
        },
        {
            title: "最新",
            type: "quote",
            value: "认沽认购期权最新价",
            sort: true,
        },
        {
            title: "涨跌幅",
            type: "quote",
            value: "认沽认购期权涨跌幅",
            sort: true,
        },
        {
            title: "涨跌额",
            type: "quote",
            value: "认沽认购期权涨跌额",
            sort: true,
        },
        {
            title: "持仓量",
            type: "quote",
            value: "认沽认购期权持仓量",
            sort: true,
        },
        {
            title: "成交量",
            type: "quote",
            value: "认沽认购期权成交量",
            sort: true,
        },
        {
            title: "隐含波动率",
            type: "quote",
            value: "认沽认购期权隐含波动率",
            sort: true,
            tip: "<span class='icon_qa_tit' title='隐含波动率(Implied Volatility)是将市场上的期权或权证交易价格代入权证理论价格模型<Black-Scholes模型>，反推出来的波动率数值'></span>"
        },
        {
            title: "折溢价率",
            type: "quote",
            value: "认沽认购期权折溢价率",
            sort: true,
            tip: "<span class='icon_qa_tit' title='期权到期前，标的物价格需要变动多少百分比才可让期权投资者在到期日实现损益平衡。溢价率衡量期权风险高低，该值越高，实现损益平衡越不容易，投资风险越高'></span>"
        }
    ]
};
